module.exports = __webpack_public_path__ + "static/media/87 - Kurt Vile - Wakin on a Pretty Day.954e22d6.mp3";